/**
 * Services Data for SENKAY Personal und Logistik
 * All service offerings with detailed information
 */

export const servicesData = [
  {
    id: 'gebaeudemanagement',
    slug: 'gebaeudemanagement',
    title: 'Gebäudemanagement',
    shortDescription: 'Professionelles Facility Management für Ihre Immobilien',
    description: 'Umfassende Gebäudemanagement-Lösungen für gewerbliche und öffentliche Objekte. Von der technischen Betreuung bis zur Reinigung - wir sorgen für einen reibungslosen Betrieb Ihrer Immobilien.',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
    category: 'Facility',
    features: [
      'Technisches Gebäudemanagement',
      'Infrastrukturelles Gebäudemanagement',
      'Kaufmännisches Gebäudemanagement',
      'Objektbetreuung und -überwachung',
      'Instandhaltung und Wartung',
      'Energiemanagement'
    ],
    benefits: [
      'Wertsteigerung Ihrer Immobilie',
      'Kostenoptimierung durch effiziente Prozesse',
      'Rechtssicherheit bei Betreiberverantwortung',
      'Zentrale Ansprechpartner für alle Belange'
    ],
    targetAudience: 'Immobilieneigentümer, Hausverwaltungen, Gewerbebetriebe',
    processSteps: [
      'Bestandsaufnahme und Objektanalyse',
      'Individuelle Konzepterstellung',
      'Implementierung der Managementsysteme',
      'Kontinuierliche Betreuung und Optimierung'
    ]
  },
  {
    id: 'arbeitnehmerueberlassung',
    slug: 'arbeitnehmerueberlassung',
    title: 'Arbeitnehmerüberlassung & Personalverleih',
    shortDescription: 'Flexible Personallösungen für Ihren kurz- und langfristigen Bedarf',
    description: 'Qualifiziertes Personal auf Zeit für alle Branchen. Wir übernehmen die Personalverwaltung, Sie konzentrieren sich auf Ihr Kerngeschäft. Rechtssicher und zuverlässig.',
    icon: 'Users',
    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80',
    category: 'Personal',
    features: [
      'Qualifizierte Fachkräfte und Helfer',
      'Kurzfristige und langfristige Einsätze',
      'Alle Branchen und Tätigkeitsbereiche',
      'Vollständige Personalverwaltung',
      'A1-Bescheinigung und Sozialversicherung',
      'Rechtskonforme Arbeitnehmerüberlassung'
    ],
    benefits: [
      'Flexibilität bei Personalengpässen',
      'Keine langfristigen Verpflichtungen',
      'Geprüfte und zuverlässige Mitarbeiter',
      'Administrative Entlastung'
    ],
    targetAudience: 'Produktion, Logistik, Handel, Handwerk, Dienstleistung',
    processSteps: [
      'Bedarfsermittlung und Anforderungsprofil',
      'Personalauswahl und -prüfung',
      'Vertragsgestaltung und Einarbeitung',
      'Laufende Betreuung und Qualitätssicherung'
    ]
  },
  {
    id: 'event-aufbau',
    slug: 'event-aufbau',
    title: 'Messe-, Event- & Konzertaufbau',
    shortDescription: 'Professioneller Auf- und Abbau für Events aller Größenordnungen',
    description: 'Erfahrene Teams für den Auf- und Abbau von Messen, Konzerten, Theatern und Veranstaltungen. Termingerecht, zuverlässig und mit dem nötigen Know-how für komplexe Logistik.',
    icon: 'Boxes',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    category: 'Events',
    features: [
      'Messeaufbau und -abbau',
      'Konzertbühnen und Veranstaltungstechnik',
      'Theaterkulissen und Bühnenaufbauten',
      'Bestuhlung und Dekoration',
      'Logistik und Transport',
      '24/7 Verfügbarkeit'
    ],
    benefits: [
      'Termingerechte Umsetzung',
      'Erfahrene und geschulte Teams',
      'Flexible Teamgrößen',
      'Eigene Logistik und Equipment'
    ],
    targetAudience: 'Eventagenturen, Messeveranstalter, Konzertveranstalter, Theater',
    processSteps: [
      'Event-Briefing und Zeitplanung',
      'Teamzusammenstellung und Logistikplanung',
      'Professioneller Auf- und Abbau',
      'Dokumentation und Übergabe'
    ]
  },
  {
    id: 'abbrucharbeiten',
    slug: 'abbrucharbeiten',
    title: 'Abbrucharbeiten & Rückbau',
    shortDescription: 'Fachgerechter Abbruch und Rückbau von Gebäuden und Anlagen',
    description: 'Professionelle Abbruch- und Rückbauarbeiten unter Einhaltung aller Sicherheits- und Umweltstandards. Von Teilrückbauten bis zu Komplettsanierungen.',
    icon: 'HardHat',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80',
    category: 'Bau',
    features: [
      'Selektiver Rückbau',
      'Komplett-Abbruch',
      'Entkernung von Gebäuden',
      'Schadstoffsanierung',
      'Entsorgungsmanagement',
      'Technischer Rückbau'
    ],
    benefits: [
      'Zertifizierte Fachkräfte',
      'Umweltgerechte Entsorgung',
      'Einhaltung aller Vorschriften',
      'Schnelle und saubere Ausführung'
    ],
    targetAudience: 'Bauunternehmen, Immobilienentwickler, Kommunen',
    processSteps: [
      'Objektbesichtigung und Konzepterstellung',
      'Genehmigungen und Vorbereitungen',
      'Fachgerechter Abbruch',
      'Entsorgung und Übergabe'
    ]
  },
  {
    id: 'bauendreinigung',
    slug: 'bauendreinigung',
    title: 'Bauendreinigung',
    shortDescription: 'Gründliche Bauendreinigung für bezugsfertige Objekte',
    description: 'Professionelle Bauendreinigung nach DIN-Standards. Wir sorgen für ein sauberes und präsentables Objekt nach Abschluss der Bauarbeiten.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
    category: 'Reinigung',
    features: [
      'Grobe Bauschlussreinigung',
      'Feine Bauendreinigung',
      'Glasreinigung',
      'Bodenbehandlung',
      'Sanitärreinigung',
      'Fassadenreinigung'
    ],
    benefits: [
      'DIN-gerechte Ausführung',
      'Termingerechte Fertigstellung',
      'Professionelles Equipment',
      'Erfahrenes Reinigungspersonal'
    ],
    targetAudience: 'Bauunternehmen, Generalunternehmer, Immobilienentwickler',
    processSteps: [
      'Objektbegehung und Angebotserstellung',
      'Koordination mit Bauleitung',
      'Durchführung der Reinigungsarbeiten',
      'Abnahme und Übergabe'
    ]
  },
  {
    id: 'stadtarbeiten',
    slug: 'stadtarbeiten',
    title: 'Stadtarbeiten & Öffentliche Ausschreibungen',
    shortDescription: 'Personal für kommunale Projekte und öffentliche Aufträge',
    description: 'Qualifiziertes Personal für städtische und kommunale Projekte. Erfahrung mit öffentlichen Ausschreibungen und Vergabeverfahren.',
    icon: 'MapPin',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&q=80',
    category: 'Öffentlich',
    features: [
      'Straßenreinigung und -wartung',
      'Grünflächenpflege',
      'Winterdienst',
      'Stadtmobiliar-Wartung',
      'Veranstaltungsbetreuung',
      'Temporäre Personalverstärkung'
    ],
    benefits: [
      'Erfahrung mit öffentlichen Ausschreibungen',
      'VOB/VOL-konforme Abwicklung',
      'Zuverlässige Leistungserbringung',
      'Flexible Personalkapazitäten'
    ],
    targetAudience: 'Kommunen, Städte, öffentliche Einrichtungen',
    processSteps: [
      'Ausschreibungsanalyse und Angebotserstellung',
      'Zuschlag und Projektplanung',
      'Personalstellung und Einsatzkoordination',
      'Dokumentation und Leistungsnachweise'
    ]
  },
  {
    id: 'eventpersonal',
    slug: 'eventpersonal',
    title: 'Hostessen, Kellner & Servicepersonal',
    shortDescription: 'Professionelles Personal für Ihre Veranstaltungen',
    description: 'Geschultes Servicepersonal für Events, Gastronomie und Hospitality. Von Hostessen über Kellner bis zu Barkeepern - wir haben die passenden Mitarbeiter.',
    icon: 'UserCheck',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80',
    category: 'Events',
    features: [
      'Hostessen und Promoter',
      'Kellner und Servicekräfte',
      'Barkeeper und Barpersonal',
      'Catering-Personal',
      'Event-Helfer',
      'VIP-Betreuung'
    ],
    benefits: [
      'Gepflegtes Erscheinungsbild',
      'Geschultes Personal',
      'Mehrsprachige Mitarbeiter verfügbar',
      'Kurzfristige Verfügbarkeit'
    ],
    targetAudience: 'Hotels, Restaurants, Catering, Eventagenturen, Messeveranstalter',
    processSteps: [
      'Event-Details und Personalanforderungen',
      'Auswahl und Briefing des Personals',
      'Event-Einsatz mit Koordination vor Ort',
      'Nachbereitung und Feedback'
    ]
  },
  {
    id: 'helfer-profis',
    slug: 'helfer-profis',
    title: 'Helfer & Fachkräfte',
    shortDescription: 'Qualifizierte Helfer und Fachkräfte für alle Branchen',
    description: 'Von ungelernten Helfern bis zu spezialisierten Fachkräften - wir stellen das passende Personal für Ihre Anforderungen.',
    icon: 'Wrench',
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&q=80',
    category: 'Personal',
    features: [
      'Produktionshelfer',
      'Lagerhelfer und Kommissionierer',
      'Handwerker verschiedener Gewerke',
      'Technische Fachkräfte',
      'Büro- und Verwaltungspersonal',
      'Spezialisten nach Anforderung'
    ],
    benefits: [
      'Breites Qualifikationsspektrum',
      'Schnelle Verfügbarkeit',
      'Vorgeprüfte Qualifikationen',
      'Flexible Einsatzdauer'
    ],
    targetAudience: 'Industrie, Handel, Handwerk, Dienstleistung',
    processSteps: [
      'Anforderungsprofil erstellen',
      'Personalvorschläge und Auswahl',
      'Onboarding und Einsatz',
      'Kontinuierliche Betreuung'
    ]
  }
];

/**
 * Service categories for filtering
 */
export const serviceCategories = [
  { id: 'all', name: 'Alle Leistungen' },
  { id: 'Personal', name: 'Personaldienstleistungen' },
  { id: 'Events', name: 'Event & Messe' },
  { id: 'Facility', name: 'Gebäude & Facility' },
  { id: 'Bau', name: 'Bau & Abbruch' },
  { id: 'Reinigung', name: 'Reinigung' },
  { id: 'Öffentlich', name: 'Öffentliche Aufträge' }
];

/**
 * Get service by slug
 */
export function getServiceBySlug(slug) {
  return servicesData.find(service => service.slug === slug);
}

/**
 * Get services by category
 */
export function getServicesByCategory(category) {
  if (category === 'all') return servicesData;
  return servicesData.filter(service => service.category === category);
}

/**
 * Get related services
 */
export function getRelatedServices(currentSlug, limit = 3) {
  const currentService = getServiceBySlug(currentSlug);
  if (!currentService) return [];

  return servicesData
    .filter(service =>
      service.slug !== currentSlug &&
      service.category === currentService.category
    )
    .slice(0, limit);
}
